import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Col, Button, Image, InputNumber } from "antd";
import { deleteProductImage, updateProductImage } from "../../../actions/productDetails";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const ShowImage = ({ details, deleteProductImage, updateProductImage, setnewimage, newimage }) => {
  const { REACT_APP_API_URL } = process.env;
  
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: details.id.toString() });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 1 : 0,
    opacity: isDragging ? 0.5 : 1,
    // Required for touch-based drag to work correctly on Safari/iOS
    touchAction: "none",
  };

  const removerImage = (e) => {
    e.stopPropagation();
    deleteProductImage(details.id);
    setnewimage(!newimage);
  };

  const updateOrder = (value) => {
    updateProductImage(details.id, { order: value }).then(() => {
      setnewimage(!newimage);
    });
  };

  return (
    <Col 
      span={3} 
      offset={1} 
      ref={setNodeRef} 
      style={style} 
      {...attributes} 
      {...listeners}
    >
      <div style={{ position: 'relative', cursor: 'grab' }}>
        <Image
          src={`${details.thumbnail}`}
          preview={false}
          style={{
            width: "100%",
            marginBottom: ".5rem",
          }}
        />
        <div 
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
          onTouchStart={(e) => e.stopPropagation()}
        >
          {/* <InputNumber
            min={0}
            defaultValue={details.order}
            onBlur={(e) => updateOrder(e.target.value)}
            style={{ width: "100%", marginBottom: ".5rem" }}
            placeholder="Order"
          /> */}
          {/* {details.order} */}
          <Button size="small" type="link" onClick={removerImage}>
            Remove
          </Button>
        </div>
      </div>
    </Col>
  );
};

export default connect(null, { deleteProductImage, updateProductImage })(ShowImage);
